<script>
import utilsMixin from '@shared/mixins/utils';

export default {
  mixins: [utilsMixin],
  props: {
    participation: {
      type: Object,
      required: true,
    },
  },
  computed: {
    isEnded() {
      return this.participation.meeting_status === 'ended';
    },
    statusTag() {
      if (!this.isEnded) {
        return { label: 'À venir', class: 'is-info' };
      }

      if (this.participation.attended) {
        return { label: 'Présent', class: 'is-success' };
      }

      return { label: 'Absent', class: 'is-light' };
    },
  },
};
</script>

<template>
  <article class="box">
    <div class="columns is-multiline">
      <div class="column is-12">
        <h3 class="title is-5">
          <router-link
            :to="{ name: 'classe_virtuelle_meeting', params: { meetingId: participation.meeting_id } }"
          >
            {{ participation.meeting_title }}
          </router-link>
          <span class="tag ml-2" :class="statusTag.class">
            {{ statusTag.label }}
          </span>
        </h3>
        <p v-if="!isEnded" class="is-block is-size-8 has-text-grey-dark">
          <span v-if="participation.added_at" class="is-block mb-1">
            Date d'inscription : {{ participation.added_at | momentFromUTC | moment('DD/MM/YY [à] HH:mm') }}
          </span>
          <span class="is-block">
            Classe virtuelle prévue le {{ participation.meeting_date | momentFromUTC | moment('DD/MM/YY [à] HH:mm') }}
          </span>
        </p>
        <p v-else class="is-block is-size-8 has-text-grey-dark">
          Le {{ participation.meeting_date | momentFromUTC | moment('DD/MM/YY [à] HH:mm') }}
        </p>
      </div>
      <div v-if="isEnded" class="column is-12">
        <div class="p-3 border-grey-2 bradius-8 overflow-hidden">
          <div class="columns is-multiline has-text-centered is-size-8">
            <div class="column is-4">
              <h4 class="title is-7 mb-2">
                Durée de présence
              </h4>
              <p v-if="participation.participation_duration_seconds != null">
                {{ participation.participation_duration_seconds | formatSeconds }}
              </p>
              <p v-else>
                Pas de participation
              </p>
            </div>
            <div class="column is-4">
              <h4 class="title is-7 mb-2">
                Temps de parole
              </h4>
              <p v-if="participation.speech_time_seconds">
                {{ participation.speech_time_seconds | formatSeconds }}
              </p>
              <p v-else>
                Pas de temps de parole
              </p>
            </div>
            <div class="column is-4">
              <h4 class="title is-7 mb-2">
                Émargé le
              </h4>
              <p v-if="participation.signed_at">
                {{ participation.signed_at | momentFromUTC | moment('DD/MM/YY [à] HH:mm') }}
              </p>
              <p v-else>
                Pas d'émargement
              </p>
            </div>
            <div class="column">
              <h4 class="title is-7 mb-2">
                Satisfaction
              </h4>
              <b-tooltip
                v-if="participation.satisfaction_rating != null"
                :active="!!participation.satisfaction_comment"
                :label="participation.satisfaction_comment"
                multilined
              >
                {{ participation.satisfaction_rating }} / 5
              </b-tooltip>
              <p v-else>
                Pas de satisfaction
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </article>
</template>
